export default "__VITE_ASSET__B_nIQ_$E__"